export default () => [
  {
    type: 'checkbox',
    align: 'center',
    width: 40,
  },
  {
    field: 'col-opt',
    title: '操作',
    headerAlign: 'center',
    align: 'left',
    width: 50,
    slots: {
      default: 'opt',
    },
  },
  {
    type: 'expand',
    align: 'center',
    width: 60,
    title: '展开',
    slots: {
      content: 'expandContent',
    },
  },
  {
    field: 'v_chartersBillingPlan',
    align: 'center',
    minWidth: 100,
    title: '包车计费方式',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'v_linkLine',
    align: 'center',
    width: 100,
    title: '是否关联线路',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'originPointName',
    align: 'center',
    minWidth: 170,
    title: '发货方名称',
    showHeaderOverflow: 'title',
    showOverflow: true,
  },
  {
    field: 'origin',
    align: 'center',
    minWidth: 150,
    title: '始发地',
    showHeaderOverflow: 'title',
    showOverflow: true,
  },
  {
    field: 'destPointName',
    align: 'center',
    minWidth: 170,
    title: '收货方名称',
    showHeaderOverflow: 'title',
    showOverflow: true,
  },
  {
    field: 'dest',
    align: 'center',
    minWidth: 150,
    title: '目的地',
    showHeaderOverflow: 'title',
    showOverflow: true,
  },
  {
    field: 'v_vehicleModel',
    align: 'center',
    width: 100,
    title: '车型',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  // {
  //   field: 'modifyByName',
  //   title: '修改人',
  //   headerAlign: 'center',
  //   align: 'center',
  //   width: 100,
  //   showHeaderOverflow: 'title',
  //   showOverflow: 'ellipsis',
  // },
  {
    field: 'modifyTime',
    title: '修改时间',
    headerAlign: 'center',
    align: 'center',
    width: 160,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
]
